import { NotificationDescription } from './util';

export const TOGGLE_NOTIFICATION = 'TOGGLE_NOTIFICATION';

export interface ToggleNotificationAction extends NotificationDescription {
  type: typeof TOGGLE_NOTIFICATION;
}

export type NotificationAction = ToggleNotificationAction;
